// Drag-Drop-attachment
var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Behaviors = require('Behaviors');
var Marionette = require('marionette');

// Drag-Drop-attachment item-view. Expects that the template contains a 'select' element.
var View = Marionette.View.extend({
    behaviors: [Behaviors.MobileView],
    events: {
        'change @ui.file': 'file',
        'click @ui.addAttachment': 'addAttachment',
        'click @ui.file': 'resetFileValue'
    },
    template: '#dragDropTemplate',
    className:'droppable-area',
    ui: {
        file: '#file',
        addAttachment: "#addAttachment",
        dragDropDiv: '#dragDropDiv',
        form: '#form',
        dragDropLabel: '#dragDropLabel'
    },
    addAttachment: function () {
        this.ui.file.click();
    },
    resetFileValue: function () {
        this.ui.file.val(null);
    },
    file: function () {
        var form = new FormData(_.first(this.ui.form));
        var file = form.get ? form.get('file') : this.ui.file[0].files[0];
        var files = this.ui.file[0].files;
        files && this.getOption('change').call(this, files);
    },
    onAttach: function () {
        var scope = this;
        this.$el.on("drop", function (ev) {
            ev.preventDefault();
            var dataTransfer = ev.originalEvent.dataTransfer;
            if (dataTransfer && dataTransfer.files.length) {
                // Use DataTransferItemList interface to access the file(s)
                var files = dataTransfer.files;
                files && scope.getOption('change').call(this, files);

            }
            scope.$el.removeClass("highlight-dashed");
        });
        this.$el.on("dragover", function (event) {
            scope.$el.addClass("highlight-dashed");
            return event.preventDefault();
        });
        this.$el.on("dragleave", function (event) {
            scope.$el.removeClass("highlight-dashed");
            return event.preventDefault();
        });
    }
});

module.exports.show = function (options) {
    var region = options.region;

    region.show(new View(options));
};


// WEBPACK FOOTER //
// ./js/Modules/UI/DragDrop.js